// extracted by mini-css-extract-plugin
export default {"navContainer":"Nav_navContainer__oFo4n","active":"Nav_active__OwXBQ","navLabel":"Nav_navLabel__mYZf2","fadeInUp":"Nav_fadeInUp__1QlAv","mobileLabel":"Nav_mobileLabel__fq7qI"};